<template>
    <a-layout-sider v-model="collapsed" :trigger="null" collapsible>
        <a-menu
                mode="inline"
                theme="dark"
                :open-keys="openKeys"
                @openChange="onOpenChange"
        >
            <a-menu-item @click="collapsed = !collapsed">
                <a-icon :type="collapsed?'right':'left'"/>
            </a-menu-item>
            <a-sub-menu v-for=" item in menu" :key="item.name">
                <span slot="title"><a-icon :type="item.icon"/><span>{{item.name}}</span></span>
                <template v-for="childrenTwo in item.children">
                    <a-menu-item
                            v-if="childrenTwo.children===undefined||childrenTwo.children===null"
                            :key="childrenTwo.name"
                            @click="routerPush(childrenTwo.router)">
                        {{childrenTwo.name}}
                    </a-menu-item>
                    <a-sub-menu v-else :key="childrenTwo.name">
                        <span slot="title">{{childrenTwo.name}}</span>
                        <a-menu-item v-for="childrenThree in childrenTwo.children" :key="childrenThree.name"
                                     @click="routerPush(childrenThree.router)">
                            {{childrenThree.name}}
                        </a-menu-item>
                    </a-sub-menu>
                </template>
            </a-sub-menu>
        </a-menu>
    </a-layout-sider>
</template>
<script>

    export default {
        data() {
            return {
                collapsed: true,
                openKeys: []
            }
        },
        methods: {
            //路由跳转
            routerPush(menuRouter) {
                this.$router.push({path: menuRouter})
            },
            onOpenChange(openKeys) {
                const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
                let index = this.menu.findIndex(item => {
                    return item.name === latestOpenKey
                });
                if (index === -1) {
                    this.openKeys = openKeys;
                } else {
                    this.openKeys = latestOpenKey ? [latestOpenKey] : [];
                }
            },
        },
        props: {
            menu: {
                type: Array,
                default() {
                    return []
                }
            }
        }
    }
</script>
